import React from "react";

type State = { error?: Error };
class ErrorBoundary extends React.Component<any, State> {
  state = { error: undefined };

  static getDerivedStateFromError(error: any): State {
    return { error: error };
  }

  _retry = () => {
    // This ends up calling loadQuery again to get and render
    // a new query reference
    this.props.onRetry();
    this.setState({
      // Clear the error
      error: undefined,
    });
  };

  render() {
    const { children, fallback } = this.props;
    const { error } = this.state;
    if (error) {
      if (typeof fallback === "function") {
        return fallback({ error, retry: this._retry });
      }
      return fallback;
    }
    return children;
  }
}

export default ErrorBoundary;
